import React from 'react';

import { get } from '@lumapps/constants';
import { useSelector } from '@lumapps/redux/react';
import { isConnectedAs, isViewAsModeEnabled } from '@lumapps/user/ducks/selectors';
import { DelayedSuspense } from '@lumapps/utils/components/DelayedSuspense';

import { isGDPRBannerEnabled } from './ducks/selectors';
import { useGdprBanner } from './hooks/useGdprBanner';

const { isMobileAppWebView } = get();

const LazyGdprBanner = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'gdpr-banner' */
            './components/GdprBanner'
        ),
);

export const GdprBanner = () => {
    const isGDPRBannerFeatureEnabled = useSelector(isGDPRBannerEnabled);
    const isInViewAsMode = useSelector(isConnectedAs);
    const isViewAsFFEnabled = useSelector(isViewAsModeEnabled);

    const { hasUserClosedBanner } = useGdprBanner();

    const showGdprBanner =
        !isMobileAppWebView &&
        !hasUserClosedBanner &&
        isGDPRBannerFeatureEnabled &&
        !(isInViewAsMode && isViewAsFFEnabled);

    return (
        <DelayedSuspense shouldLoad={showGdprBanner}>
            <LazyGdprBanner />
        </DelayedSuspense>
    );
};
